import { externalNetworkClient } from '@terra/shared-rest-clients-external-network';
import type { ExternalNetworkContract } from '@terra/shared-contracts-external-network';
import { tenantAwareApiWrapper, withOrchestratorClient } from './api-core';

export const externalNetworkScanProfilesApi = {
  listScanProfiles: () =>
    tenantAwareApiWrapper<typeof ExternalNetworkContract.listScanProfiles>({
      endpointFn: (headers) =>
        externalNetworkClient.listScanProfiles({
          ...withOrchestratorClient(headers),
        }),
    }),

  assignExternalNetworkScanProfile: ({
    surfaceId,
    scanProfileId,
  }: {
    surfaceId: string;
    scanProfileId: string;
  }) =>
    tenantAwareApiWrapper<
      typeof ExternalNetworkContract.assignExternalNetworkScanProfile
    >({
      endpointFn: (headers) =>
        externalNetworkClient.assignExternalNetworkScanProfile({
          params: { surfaceId },
          body: { scanProfileId },
          ...withOrchestratorClient(headers),
        }),
      useBodyMessage: true,
    }),
};
